import { siteConfig, IMAGES } from "@/data/siteConfig";
import { Reveal } from "./shared";

export const ChallengeSection = () => {
  const { why } = siteConfig;
  return (
    <section id="why" data-testid="why-section" className="relative bg-navy py-24 lg:py-36 grain overflow-hidden">
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-2 lg:gap-24 items-start">
          <div>
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">{why.eyebrow}</p>
              <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-cream sm:text-5xl">
                {why.heading}
              </h2>
              <p className="mt-8 max-w-xl text-lg leading-relaxed text-cream/70">{why.body}</p>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="relative">
              <img
                src={IMAGES.brotherhood}
                alt="Young men standing together in community"
                className="w-full h-[420px] object-cover"
              />
              <div className="absolute inset-0 vignette" />
            </div>
          </Reveal>
        </div>

        <div className="mt-20 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-3">
          {why.stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.1} className="bg-navy p-10">
              <div className="font-display text-5xl text-gold lg:text-6xl">{s.value}</div>
              <p className="mt-4 text-sm leading-relaxed text-cream/60">{s.label}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <blockquote className="mt-24 max-w-4xl">
            <p className="font-display text-3xl italic leading-snug text-cream sm:text-4xl lg:text-[2.75rem]">
              &ldquo;{why.quote}&rdquo;
            </p>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};
